<template>
  <section class="content">
    <!-- Default box -->
    <div class="box">
            <div class="box-header">
              <h3 class="box-title"><b>Interviewer Report</b></h3>
              <hr>
            </div>
            <!-- /.box-header -->
            <div class="box-body" style="min-height: 800px;height: auto;">
              <div class="box-header with-border" style="padding: 11px;padding-right: 0px;">
              </div>
              <div id="example1_wrapper" class="dataTables_wrapper form-inline dt-bootstrap">
                <div class="row">
                  <div class="col-sm-12" v-if="userslistlength > 0">
                  </div>
                  <div class="col-sm-12">
                    <div style="margin-top: 20%;text-align:center" v-if="userslistlength < 1">
                      <img src="../../assets/img/nodata.svg" alt="Product Image" style="width: 80px;">
                    </div>
                    <div class="table-responsive text-nowrap">
                  <table v-if="userslistlength > 0" id="example1" class="table table-striped" role="grid" aria-describedby="example1_info" style="font-size: 12px">
                <thead>
                  <tr role="row">
                    <th class="sorting_asc" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-sort="ascending" aria-label="Rendering engine: activate to sort column descending" style="width: 44px;">S.No</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="Browser: activate to sort column ascending">Interviewer Name</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="Browser: activate to sort column ascending">Email</th>
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="Browser: activate to sort column ascending">Mobile Number</th>
                    <!-- <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="Browser: activate to sort column ascending">Skills</th> -->
                    <th class="sorting" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="Browser: activate to sort column ascending">Availability and Skills</th>
                  </tr>
                </thead>
                <tbody>
                  <tr role="row" class="odd" v-for="(x, index) in userslist" :key="index">
                    <td>{{index + 1 }}</td>
                    <td>{{x.interviewer_name}}</td>
                    <td>{{x.interviewer_email}}</td>
                    <td>{{x.mobile_number_code}}-{{x.mobile_number}}</td>
                    <!-- <td><div class="skillbox">{{x.userskillnames}}</div></td> -->
                    <td><button class="btn btn-success" @click="showAvailability(x.availability, 'startdate', x.userskillnames)" style="padding: 2px 5px;">Availability & Skills</button></td>
                  </tr>
                </tbody>
              </table></div></div></div>
              <div class="row" v-if="totalPages > 9">
                <div class="col-sm-3">
                  <div class="dataTables_info" id="example1_info" role="status" aria-live="polite"></div>
                </div>
                <div class="col-sm-7">
                  <jw-pagination :items="pages" @changePage="onChangePage"></jw-pagination>
                </div>
                </div>
              </div>
            </div>
            <!-- /.box-body -->
          </div>
          <div class="modal overlay fade in" id="myModal1">
            <div class="modal-dialog" style="margin-top:115px !important;width: 750px !important;">
              <div class="modal-content" style="width: 750px;margin-left: auto;margin-right: auto;border-radius: 7px;">
                <div class="modal-header">
                  <div style="padding: 6px;" class="title is-4 text-bold custom-post-title">{{ 'Availability & Skills' }}<span class="pop-up-close-icon" data-dismiss="modal"><i data-v-33f01075="" aria-hidden="true" class="uil uil-times"></i></span></div>
                </div>
                <div class="modal-body" style="padding:0px">
                  <div class="row" >
                    <div class="col-md-12 " style="padding:17px">
                      <!-- <div class="col-md-12" style="text-align: center;">
                        <p style="font-size: 20px;font-weight: 600;">Window Violated</p><br>
                        <button class="btn btn-success" @click="closepopup()">Close</button>
                      </div> -->
                        <div class="col-md-1"><b>Skills:</b></div>
                        <div class="col-md-11">{{skills}}</div>
                        <div class="col-md-12"><hr></div>
                        <div class="row mt-2" v-for="(date, index) in groupeddate" :key="index">
                          <div class="col-md-2 p-1 tc"><b>{{index}} <br> {{index | getDay}}</b></div>
                          <div class="col-md-10">
                            <ul class="donate-now mt-0">
                              <li v-for="d in date" :key="d.start_datetime" style="width: 136px;height: 33px;" @click="getdatetime(d)">
                                <input type="radio" :id="d.start_datetime" name="time" />
                                <label :for="d.start_datetime">{{d.start_time}} - {{d.end_time}}</label>
                              </li>
                            </ul>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /.modal-content -->
            </div>
          </div>
  </section>
</template>

<script>

import axios from 'axios'
import { BaseURL } from '../../shared/classes'
import $ from 'jquery'
import Vue from 'vue'
import JwPagination from 'jw-vue-pagination'
import momentsone from 'moment-timezone'
Vue.component('jw-pagination', JwPagination)
// Vue.use(excel)
export default {
  name: 'tabs-card',
  data () {
    return {
      title: '',
      pageOfItems: [],
      totalPages: 0,
      pages: [],
      groupeddate: [],
      showlist: false,
      skills: '',
      config: {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      },
      viewdetails: false,
      adduser: true,
      userslistlength: '',
      userInfo: JSON.parse(localStorage.getItem('user__details')),
      json_data: [],
      email: '',
      currentTimeZone: momentsone.tz.guess()
    }
  },
  created () {
    this.getalldata()
    console.log(this.userInfo.user_email)
    this.email = this.userInfo.user_email
    this.$root.$emit('navigate', 'Report')
  },
  methods: {
    showAvailability (array, key, skills) {
      this.skills = skills
      const result = {}
      this.groupeddate = []
      array.forEach(item => {
        if (!result[item[key]]) {
          result[item[key]] = []
          // this.groupeddate.push(item);
        }
        result[item[key]].push(item)
      })
      this.groupeddate = result
      console.log(this.groupeddate)
      $('#myModal1').modal('show')
    },
    closepopup () {
      $('#myModal1').modal('show')
    },
    groupBy (array, key) {
      const result = {}
      this.groupeddate = []
      array.forEach(item => {
        if (!result[item[key]]) {
          result[item[key]] = []
          // this.groupeddate.push(item);
        }
        result[item[key]].push(item)
      })
      this.groupeddate = result
    },
    getalldata () {
      var timezone1 = ''
      if (this.currentTimeZone === 'America/New_York') {
        timezone1 = 'EST'
      } else {
        timezone1 = 'IST'
      }
      axios.get(`${BaseURL}/dashboard/get_interviewerandavailability_acs/web/` + timezone1, this.config).then(response => {
        this.userslist = response.data.interviewer_list
        this.userslistlength = response.data.interviewer_list.length
      })
    },
    onChangePage (pageOfItems) {
      // update page of items
      console.log(pageOfItems[0].name)
      const mainurl = '/dashboard/get_interview_report/' + this.userInfo._id + '/' + pageOfItems[0].name
      axios.get(`${BaseURL}${mainurl}`, this.config).then(response => {
        this.userslist = response.data.interview_report
        this.userslistlength = response.data.interview_report.length
        this.pageOfItems = pageOfItems[0].name + 1
      }).catch(e => {
        console.log(e)
      })
    }
  }

}
</script>

<style scoped>
.products-list .item:hover {
  border-left: 3px solid #ffffff;
  background-color: #ffffff;
  cursor: pointer;
}
a:hover, a:active, a:focus {
  outline: none;
  text-decoration: none;
  color: #5bad2b;
}
.errorshow {
  background-color: #ff000047;
  padding: 5px;
  color: #dd4b39 !important;
}
.post li.active {
  background-color: #5bad2b !important;
  color: white;
  border: 0px !important;
}
.sideborder {
  border-right: 1px solid #cccccc52;
  min-height: 700px;
  height: 100%;
}
span.field-icon {
  position: absolute;
  display: inline-block;
  cursor: pointer;
  right: 2.5rem;
  top: 0.7rem;
  z-index: 2;
  margin-top: 4px;
}
hr {
  margin-top: 9px;
  margin-bottom: 9px;
}
.donate-now {
  list-style-type: none;
  margin: 25px 0 0 0;
  padding: 0;
}

.donate-now li {
  float: left;
  margin: 0 5px 0 0;
  width: 112px;
  height: 52px;
  position: relative;
}

.donate-now input[type="radio"]:checked+label,
.Checked+label {
  background: #fff;
  color:#ddd;
}

.donate-now label {
  padding: 5px;
  border: 1px solid #ccc;
  cursor: pointer;
  z-index: 90;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
}

.donate-now label:hover {
  background: #fff;
}
.table>thead>tr>th {
    border: 2px solid #f4f4f4;
    text-align: center;
}
.table>tbody>tr>td {
    border: 2px solid #f4f4f4;
    text-align: center;
}
</style>
